import { SvgIcon } from '@volue/wave-react';
import type { IconToken } from '@volue/wave-react/dist/ts/components/SvgIcon';
import React from 'react';

import { useActions } from '@/overmind';
import type { OpenPagePayload } from '@/overmind/actions';

type LinkNavProps = {
  label: string;
  link: OpenPagePayload;
  isSelected?: boolean;
  iconName: IconToken;
};

export function LinkNavItem({
  label,
  link,
  isSelected,
  iconName
}: LinkNavProps) {
  const { pageOpened } = useActions();
  return (
    <a
      className={`sidebarNav-item ofH ${
        isSelected ? 'sidebarNav-item--active' : ''
      }`}
      onClick={() => {
        pageOpened(link);
      }}
    >
      <SvgIcon iconName={iconName} className="mRm mLs" />
      {label}
    </a>
  );
}
